import { TaggedError } from "@for-it/domain-lib";
export class PaymentCredentialsInvalidError extends TaggedError {
    constructor() {
        super("PaymentCredentialsInvalidError");
    }
}
